<script>
  import ContratoService from '../../../../domain/contrato/services/contrato'
  import ContaBancariaService from '../../../../domain/conta-bancaria/services/conta-bancaria'
  import CategoriasVeicularesService from '../../../../domain/bem-categoria/services/categorias-veiculares'
  import { isArray } from 'lodash'
  import estadosBr from '../../../_default/utils/estados-brasileiros'
  import { VueMaskDirective as mask } from 'v-mask'
  import {REAL_BRL} from '../../../../utils/helpers/money'
  import { VMoney } from 'v-money'
  import {number_format as numberFormat} from '../../../../utils/helpers/phpjs'

  const CATEGORIA_CONTRATO_MODEL = {
    valorDiaria: 0.0,
    valorHoraServicoAdicional: 0.0,
    valorKmAdicional: 0.0,
    valorReboque: 0.0,
    bemCategoria: null
  }

  export default {
    nome: 'novo-contrato',
    components: {},
    directives: {mask, money: VMoney},
    data () {
      return {
        money: REAL_BRL,
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        data: {
          id: null,
          nome: '',
          descontoFimDeSemana: false,
          descontoFeriado: false,
          limiteDiarias: 0,
          cobrarTaxaBancaria: false,
          valorKmForaDaCidade: 0.0,
          usaGgv: false,
          contaBancaria: null,
          categoriasContratos: [
            {...CATEGORIA_CONTRATO_MODEL}
          ]
        },
        contasBancarias: null,
        categoriasVeiculares: null,
        showCadastroContaBancaria: false,
        showCadastroCategoriaVeicular: false
      }
    },
    computed: {
      estadosBr () {
        return estadosBr
      }
    },
    created () {
      this.loadContasBancarias()
      this.loadCategoriasVeiculares()
    },
    mounted () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      start () {
        if (this.$route.params.id) {
          this.$loaderOverlay.open().message('Carregando')
          ContratoService.find(this.$route.params.id)
            .then((response) => {
              this.isLoaded = true
              this.$loaderOverlay.hide()
              this.data = response.data
              // TODO: GAMBIARRA; VERIFICAR SE HÁ MELHOR FORMA
              this.data.contaBancaria = this.data.contaBancaria && this.data.contaBancaria.id || null
              this.data.categoriasContratos = response.data.categoriasContratos.map(item => {
                item.bemCategoria = item.bemCategoria.id
                item.valorDiaria = numberFormat(item.valorDiaria, 2, ',', '.')
                item.valorHoraServicoAdicional = numberFormat(item.valorHoraServicoAdicional, 2, ',', '.')
                item.valorKmAdicional = numberFormat(item.valorKmAdicional, 2, ',', '.')
                item.valorReboque = numberFormat(item.valorReboque, 2, ',', '.')
                return item
              })
              console.log(this.data.categoriasContratos)
              console.log(response)
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              console.log(response)
            })
        } else {
          this.isLoaded = true
          // this.$loaderOverlay.open().message('Aguarde')
        }
      },
      submit () {
        /* eslint-disable */
        return false
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$loaderOverlay.open().message('Processando...')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde...')
        }, 1000)
        const request = this.prepararDados()
        ContratoService.cadastrar(request, this.$route.params.id).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionr para tela de visualização
              // this.$router.push({name: 'documento.editar', params: {id: response.data.id}})
              this.atualizadoSucesso = true
            }
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      prepararDados () {
        // const clearNumber = str => str.replace(/\D/g, '')
        const convertMoneyToFloat = str => +str.replace(/^\D*/, '').replace(/\./, '').replace(/,/, '.')
        const tmp = {...this.data}
        tmp.valorKmForaDaCidade = convertMoneyToFloat(tmp.valorKmForaDaCidade)
        tmp.categoriasContratos = tmp.categoriasContratos.map(item => ({
          valorDiaria: convertMoneyToFloat(item.valorDiaria),
          valorHoraServicoAdicional: convertMoneyToFloat(item.valorHoraServicoAdicional),
          valorKmAdicional: convertMoneyToFloat(item.valorKmAdicional),
          valorReboque: convertMoneyToFloat(item.valorReboque),
          bemCategoria: item.bemCategoria
        }))
        return {...tmp}
      },
      loadContasBancarias () {
        ContaBancariaService.list(100000, 1, '')
          .then(result => {
            this.contasBancarias = result.data.result
            console.log(this.contasBancarias)
          })
          .catch(error => {
            console.log(error)
          })
      },
      loadCategoriasVeiculares () {
        CategoriasVeicularesService.list(100000, 1, '')
          .then(result => {
            this.categoriasVeiculares = result.data.result
            console.log(this.categoriasVeiculares)
          })
          .catch(error => {
            console.log(error)
          })
      },
      addValorCategoria () {
        this.data.categoriasContratos.push({...CATEGORIA_CONTRATO_MODEL})
      },
      removeValorCategoria (index) {
        if (window.confirm('Tem certeza de que deseja remover os valores para essa categoria?')) {
          this.data.categoriasContratos.splice(index, 1)
        }
      },
      closeCadastroContaBancaria () {
        this.showCadastroContaBancaria = false
        this.loadContasBancarias()
      },
      closeCadastroCategoriaVeicular () {
        this.showCadastroCategoriaVeicular = false
        this.loadCategoriasVeiculares()
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Contrato</h1></div>
          <div class="col-sm-6">
            <router-link :to="{name: 'config.cadastro-publico.list'}"
                         class="pull-right hidden-print" style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
            </router-link>
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">
              <div class="form-group">
                <label class="col-sm-4 control-label">Proprietário do veículo</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" required/>
                </div>
              </div><!--/-->

              <div class="form-group">
                <label class="col-sm-4 control-label">CPF do Proprietário</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" required/>
                </div>
              </div><!--/-->

              <div class="form-group">
                <label class="col-sm-4 control-label">E-mail Alternativo</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" required/>
                </div>
              </div><!--/-->

              <div class="form-group">
                <label class="col-sm-4 control-label">Telefone 1</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" required/>
                </div>
              </div><!--/-->

              <div class="form-group">
                <label class="col-sm-4 control-label">Telefone 2</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" required/>
                </div>
              </div><!--/-->

              <div class="form-group">
                <label class="col-sm-4 control-label">Telefone 3</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" required/>
                </div>
              </div><!--/-->

              <div class="form-group">
                <label class="col-sm-4 control-label">Telefone 4</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" required/>
                </div>
              </div><!--/-->

              <hr>

              <div class="form-group">
                <label class="col-sm-4 control-label">Fabricante</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" required/>
                </div>
              </div><!--/-->

              <div class="form-group">
                <label class="col-sm-4 control-label">Modelo</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" required/>
                </div>
              </div><!--/-->

              <div class="form-group">
                <label class="col-sm-4 control-label">Placa</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" required/>
                </div>
              </div><!--/-->

              <div class="form-group">
                <label class="col-sm-4 control-label">Número Chassi</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" required/>
                </div>
              </div><!--/-->

              <div class="form-group">
                <label class="col-sm-4 control-label">Seguradora</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" required/>
                </div>
              </div><!--/-->

              <div class="form-group">
                <label class="col-sm-4 control-label">Apólice ou Sinistro</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" required/>
                </div>
              </div><!--/-->

              <div class="form-group">
                <label class="col-sm-4 control-label">Data Comunicação</label>
                <div class="col-sm-8">
                  <p>28/01/2014</p>
                </div>
              </div><!--/-->

              <div class="form-group">
                <label class="col-sm-4 control-label">Pátio do Veículo</label>
                <div class="col-sm-8">
                  <p>Pátio de Deodoro - Município do RJ</p>
                </div>
              </div><!--/-->

              <div class="form-group">
                <label class="col-sm-4 control-label">Baixa</label>
                <div class="col-sm-8">
                  <input type="checkbox" required/>
                </div>
              </div><!--/-->

              <div class="form-group">
                <label for="observacoesGev" class="col-sm-4 control-label">Observações</label>
                <div class="col-sm-8">
                          <textarea id="observacoesGev" v-model="data.observacoes" rows="7" class="form-control"
                                    style="resize: none;"></textarea>
                </div>
              </div><!--/-->

              <hr>

              <div class="form-group">
                <label class="col-sm-4 control-label">E-mail</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" required/>
                </div>
              </div><!--/-->

              <div class="form-group">
                <label class="col-sm-4 control-label">Senha</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" required/>
                </div>
              </div><!--/-->

              <div class="form-group">
                <label class="col-sm-4 control-label">Data Cadastramento</label>
                <div class="col-sm-8">
                  <p>27/01/2014 11:21:48</p>
                </div>
              </div><!--/-->

              <hr>
              <div class="row wrapper">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$router.push({name: 'config.cadastro-publico.list'})">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// NovoCadastroPublico.vue?0bd97db7